import { render, staticRenderFns } from "./DetalleAdministrativeCentre.vue?vue&type=template&id=57d653c9"
import script from "./DetalleAdministrativeCentre.vue?vue&type=script&lang=js"
export * from "./DetalleAdministrativeCentre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports